// Firebase v9+ модульный синтаксис
import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyAiL7JZvFt7gq-kCv0AabVjU2tFVDLUqE8",
  authDomain: "store-be1e1.firebaseapp.com",
  databaseURL: "https://store-be1e1.firebaseio.com",
  projectId: "store-be1e1",
  storageBucket: "store-be1e1.appspot.com",
  messagingSenderId: "185606745586",
  appId: "1:185606745586:web:fa03570cbb499ce03b0f6b",
  measurementId: "G-WD83C4CKLW"
};

// Инициализация Firebase
const app = initializeApp(firebaseConfig);

// Экспорт сервисов
export const database = getDatabase(app);
export const auth = getAuth(app);
export const firestore = getFirestore(app);

// Экспорт приложения по умолчанию для обратной совместимости
export default app;